// Equipment options
export const equipmentOptions = [
    { id: 'none', label: 'No Equipment (Mat Only)' },
    { id: 'reformer', label: 'Reformer' },
    { id: 'chair', label: 'Pilates Chair' },
    { id: 'tower', label: 'Tower/Cadillac' },
    { id: 'ball', label: 'Exercise Ball' },
    { id: 'band', label: 'Resistance Band' },
    { id: 'ring', label: 'Pilates Ring' },
    { id: 'weights', label: 'Light Weights' },
    { id: 'foam_roller', label: 'Foam Roller' },
  ];
  
  // Body area options
  export const bodyAreaOptions = [
    { id: 'core', label: 'Core/Abs' },
    { id: 'arms', label: 'Arms & Shoulders' },
    { id: 'legs', label: 'Legs' },
    { id: 'glutes', label: 'Glutes' },
    { id: 'back', label: 'Back' },
    { id: 'fullbody', label: 'Full Body' },
    { id: 'flexibility', label: 'Flexibility/Mobility' },
  ];
  
  // Duration options
  export const durationOptions = [
    { value: 15, label: '15 minutes' },
    { value: 30, label: '30 minutes' },
    { value: 45, label: '45 minutes' },
    { value: 60, label: '60 minutes' },
  ];
  
  // Difficulty options
  export const difficultyOptions = [
    { value: 'all', label: 'All Levels' },
    { value: 'beginner', label: 'Beginner' },
    { value: 'intermediate', label: 'Intermediate' },
    { value: 'advanced', label: 'Advanced' },
  ];
  
  // Health considerations options
  export const healthConsiderationsOptions = [
    { id: 'wrist', label: 'Wrist Issues' },
    { id: 'back', label: 'Back Problems' },
    { id: 'knee', label: 'Knee Concerns' },
    { id: 'shoulder', label: 'Shoulder Issues' },
    { id: 'pregnancy', label: 'Pregnancy' },
    { id: 'balance', label: 'Balance Difficulties' },
  ];
  
  // Rest time options
  export const restTimeOptions = [
    { value: 15, label: '15 seconds' },
    { value: 30, label: '30 seconds' },
    { value: 45, label: '45 seconds' },
    { value: 60, label: '60 seconds' },
  ];